import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { FaSave, FaSpinner, FaTimes } from 'react-icons/fa';
import { CloseIcon, ColoredSettingsEmailConfigurationIcon } from 'ui-component/custom-icons/icons'
import toast from 'react-hot-toast';

import { Skeleton } from '@mui/material';
import CustomMUISwitch from 'ui-component/CustomMUISwitch';
import useIsMobile from 'utils/isMobileUtils';

// ✅ Clear
const EmailConfigurationModal = ({ openPopup, handleClose }) => {

    const [information, setInformation] = useState(null);
    const [isFormProcessing, setIsFormProcessing] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        initializeData()
    }, []);
    

    const initializeData = () => {

        setIsLoading(true);
        api.getSettingsGeneralEmailConfigurationSettings().then((res) => {
            setIsLoading(false);
            if (res.status) {
                setInformation({
                    smtp_mail_enabled: res?.data?.smtp_mail_enabled || 'DISABLED',
                    smtp_mail_mailer: res?.data?.smtp_mail_mailer || '',
                    smtp_mail_host: res?.data?.smtp_mail_host || '',
                    smtp_mail_port: res?.data?.smtp_mail_port || '',
                    smtp_mail_username: res?.data?.smtp_mail_username || '',
                    smtp_mail_password: res?.data?.smtp_mail_password || '',
                    smtp_mail_encryption: res?.data?.smtp_mail_encryption || '',
                    smtp_mail_from_address: res?.data?.smtp_mail_from_address || '',
                    smtp_mail_from_name: res?.data?.smtp_mail_from_name || '',

                })
            }
        });
    }


    const handleProcessSubmit = () => {
        setIsFormProcessing(true);

        toast.promise(
            api.upSettingsGeneralEmailConfigurationSettings(information)
                .then((res) => {
                    if (res.status) {
                        handleClose()
                    }

                    return res?.status == true ? res : null;
                }),

            {
                loading: 'Email configuration...',
                success: (data) => `${data.message}`,
                error: <b>Updating email configuration failed</b>
            }
        );
    }

    const isMobile = useIsMobile();
    
   if (!isMobile) return (
        <Modal show={openPopup}  centered size="md">
            <Modal.Body>
                <div className="p-2">
                    <div>
                        <div className="mb-2 ml-0 pl-0">

                            <div className="row">
                                <div className="col-12 text-center">
                                    <ColoredSettingsEmailConfigurationIcon height={'100px'} width={'100px'} />
                                </div>
                            </div>
                            <button className="btn modal-close-icon" onClick={handleClose}>
                                <CloseIcon height={'16px'} width={'16px'} />
                            </button>
                        </div>

                        <div className="row align-items-top form-group">
                            <div className="col-12 text-center " style={{ padding: '10px 0 20px 0' }}>
                                <div style={{ fontSize: '24px' }}>
                                    Email Configuration
                                </div>
                                <div className='textGray'>
                                    Manage details about your email configuration for sending emails
                                </div>
                            </div>
                        </div>
                        <div className="row align-items-top form-group">
                            <div className="col-lg-4 col-md-4 col-12">
                                <div className={`flex align-items-center justify-content-end ${isMobile ? '' : "text-right"}`}>
                                    <label htmlFor="">Enable Email Sending</label>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-12">
                                {
                                    isLoading ? (
                                        <div style={{ width: '100px' }}>
                                            <Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '12px' }} />
                                        </div>
                                    ) : (
                                        <div
                                            className="pddmi-action"
                                            onClick={(e) => {
                                                setInformation({
                                                    ...information,
                                                    smtp_mail_enabled: information?.smtp_mail_enabled === 'ENABLED' ? 'DISABLED' : 'ENABLED'
                                                });
                                            }}
                                                style={{ width: '50px' }}
                                        >
                                            <CustomMUISwitch checked={information?.smtp_mail_enabled === 'ENABLED' ? true : false } />
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                        <div className="row align-items-top form-group">
                            <div className="col-lg-4 col-md-4 col-12">
                                <div className={`flex align-items-center justify-content-end ${isMobile ? '' : "text-right"}`}>
                                    <label htmlFor="">Mailer</label>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-12">
                                
                                {
                                    isLoading ? (
                                        <div style={{ width: '100%' }}>
                                            <Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '12px' }} />
                                        </div>
                                    ) : (
                                        <input
                                            type="text"
                                            className={`form-control ${ information?.smtp_mail_enabled !== 'ENABLED' ? 'disabled cursor-disabled' : ''}`}
                                            disabled={information?.smtp_mail_enabled !== 'ENABLED' ? true : false }
                                            id="inputName"
                                            value={information?.smtp_mail_mailer}
                                            onChange={(e) => {
                                                setInformation({ ...information, smtp_mail_mailer: e.target.value });
                                            }}
                                        />
                                    )
                                }
                            </div>
                        </div>
                        
                        <div className="row align-items-top form-group">
                            <div className="col-lg-4 col-md-4 col-12">
                                <div className={`flex align-items-center justify-content-end ${isMobile ? '' : "text-right"}`}>
                                    <label htmlFor="">Host</label>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-12">
                                {
                                    isLoading ? (
                                        <div style={{ width: '100%' }}>
                                            <Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '12px' }} />
                                        </div>
                                    ) : (
                                        <input      
                                            type="text"
                                            className={`form-control ${ information?.smtp_mail_enabled !== 'ENABLED' ? 'disabled cursor-disabled' : ''}`}
                                            disabled={information?.smtp_mail_enabled !== 'ENABLED' ? true : false }
                                            id="inputName"
                                            value={information?.smtp_mail_host}
                                            onChange={(e) => {
                                                setInformation({ ...information, smtp_mail_host: e.target.value });
                                            }}
                                        />
                                    )
                                }
                            </div>
                        </div>
                        <div className="row align-items-top form-group">
                            <div className="col-lg-4 col-md-4 col-12">
                                <div className={`flex align-items-center justify-content-end ${isMobile ? '' : "text-right"}`}>
                                    <label htmlFor="">Port</label>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-12">
                                {
                                    isLoading ? (
                                        <div style={{ width: '100%' }}>
                                            <Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '12px' }} />
                                        </div>
                                    ) : (
                                        <input
                                            type="text"
                                            className={`form-control ${ information?.smtp_mail_enabled !== 'ENABLED' ? 'disabled cursor-disabled' : ''}`}
                                            disabled={information?.smtp_mail_enabled !== 'ENABLED' ? true : false }
                                            id="inputName"
                                            value={information?.smtp_mail_port}
                                            onChange={(e) => {
                                                setInformation({ ...information, smtp_mail_port: e.target.value });
                                            }}
                                        />
                                    )
                                }
                            </div>
                        </div>
                        <div className="row align-items-top form-group">
                            <div className="col-lg-4 col-md-4 col-12">
                                <div className={`flex align-items-center justify-content-end ${isMobile ? '' : "text-right"}`}>
                                    <label htmlFor="">Username</label>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-12">
                                {
                                    isLoading ? (
                                        <div style={{ width: '100%' }}>
                                            <Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '12px' }} />
                                        </div>
                                    ) : (
                                        <input
                                            type="text"
                                            className={`form-control ${ information?.smtp_mail_enabled !== 'ENABLED' ? 'disabled cursor-disabled' : ''}`}
                                            disabled={information?.smtp_mail_enabled !== 'ENABLED' ? true : false }
                                            id="inputName"
                                            value={information?.smtp_mail_username}
                                            onChange={(e) => {
                                                setInformation({ ...information, smtp_mail_username: e.target.value });
                                            }}
                                        />
                                    )
                                }
                            </div>
                        </div>
                        <div className="row align-items-top form-group">
                            <div className="col-lg-4 col-md-4 col-12">
                                <div className={`flex align-items-center justify-content-end ${isMobile ? '' : "text-right"}`}>
                                    <label htmlFor="">Password</label>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-12">
                                {
                                    isLoading ? (
                                        <div style={{ width: '100%' }}>
                                            <Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '12px' }} />
                                        </div>
                                    ) : (
                                        <input
                                            type="text"
                                            className={`form-control ${ information?.smtp_mail_enabled !== 'ENABLED' ? 'disabled cursor-disabled' : ''}`}
                                            disabled={information?.smtp_mail_enabled !== 'ENABLED' ? true : false }
                                            id="inputName"
                                            value={information?.smtp_mail_password}
                                            onChange={(e) => {
                                                setInformation({ ...information, smtp_mail_password: e.target.value });
                                            }}
                                        />
                                    )
                                }
                            </div>
                        </div>
                        <div className="row align-items-top form-group">
                            <div className="col-lg-4 col-md-4 col-12">
                                <div className={`flex align-items-center justify-content-end ${isMobile ? '' : "text-right"}`}>
                                    <label htmlFor="">Encryption</label>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-12">
                                {
                                    isLoading ? (
                                        <div style={{ width: '100%' }}>
                                            <Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '12px' }} />
                                        </div>
                                    ) : (
                                        <input
                                            type="text"
                                            className={`form-control ${ information?.smtp_mail_enabled !== 'ENABLED' ? 'disabled cursor-disabled' : ''}`}
                                            disabled={information?.smtp_mail_enabled !== 'ENABLED' ? true : false }
                                            id="inputName"
                                            value={information?.smtp_mail_encryption}
                                            onChange={(e) => {
                                                setInformation({ ...information, smtp_mail_encryption: e.target.value });
                                            }}
                                        />
                                    )
                                }
                            </div>
                        </div>
                        <div className="row align-items-top form-group">
                            <div className="col-lg-4 col-md-4 col-12">
                                <div className={`flex align-items-center justify-content-end ${isMobile ? '' : "text-right"}`}>
                                    <label htmlFor="">Sender Email</label>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-12">
                                {
                                    isLoading ? (
                                        <div style={{ width: '100%' }}>
                                            <Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '12px' }} />
                                        </div>
                                    ) : (
                                        <input
                                            type="text"
                                            className={`form-control ${ information?.smtp_mail_enabled !== 'ENABLED' ? 'disabled cursor-disabled' : ''}`}
                                            disabled={information?.smtp_mail_enabled !== 'ENABLED' ? true : false }
                                            id="inputName"
                                            value={information?.smtp_mail_from_address}
                                            onChange={(e) => {
                                                setInformation({ ...information, smtp_mail_from_address: e.target.value });
                                            }}
                                        />
                                    )
                                }
                            </div>
                        </div>
                        <div className="row align-items-top form-group">
                            <div className="col-lg-4 col-md-4 col-12">
                                <div className={`flex align-items-center justify-content-end ${isMobile ? '' : "text-right"}`}>
                                    <label htmlFor="">Sender Name</label>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-12">
                                {
                                    isLoading ? (
                                        <div style={{ width: '100%' }}>
                                            <Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '12px' }} />
                                        </div>
                                    ) : (
                                        <input
                                            type="text"
                                            className={`form-control ${ information?.smtp_mail_enabled !== 'ENABLED' ? 'disabled cursor-disabled' : ''}`}
                                            disabled={information?.smtp_mail_enabled !== 'ENABLED' ? true : false }
                                            id="inputName"
                                            value={information?.smtp_mail_from_name}
                                            onChange={(e) => {
                                                setInformation({ ...information, smtp_mail_from_name: e.target.value });
                                            }}
                                        />
                                    )
                                }
                            </div>
                        </div>




                        <div className="row align-items-top mt10">
                            <div className="col-12 flex justify-content-end gap-2">
                                
                                <button
                                    type="button"
                                    className="btn btn-primary btn-outlined-main-primary  white-var"
                                    disabled={isLoading || isFormProcessing}
                                    onClick={() => {
                                        if (!isFormProcessing) {
                                            handleProcessSubmit()
                                        }
                                    }}
                                    style={{ lineHeight: '25px' }}
                                >
                                    {
                                        isFormProcessing ? (
                                            <>
                                                <FaSpinner className="fa-spin" /> Saving...
                                            </>
                                        ) : (
                                            <>
                                                <FaSave /> Save
                                            </>
                                        )
                                    }
                                    
                                </button>
                                <button onClick={handleClose} className="btn btn-main-primary btn-outlined-main" style={{ marginLeft: '4px' }}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );

    return (
            <div
                className="d-flex"
                style={{
                    width: '100vw',
                    height: '100dvh',
                    position: 'fixed',
                    left: 0,
                    top: 0,
                    zIndex: 20,
                    background: 'rgba(0,0,0,0.07)',
                    justifyContent: 'center',
                    alignItems: 'end',
                    paddingBottom: '90px',
                    backdropFilter: 'blur(8px)',
                    WebkitBackdropFilter: 'blur(8px)'
                }}
            >
                <div
                    className="popup color-popup-mobile d-md-none"
                    style={{
                        position: 'relative',
                        transform: 'none',
                        top: 0,
                        left: 0,
                        maxWidth: '90%',
                        background: '#fff',
                        borderRadius: 12,
                        boxShadow: 'rgb(0 0 0 / 37%) 0px 0px 20px',
                        width: '100%',
                        padding: '24px 16px 0 16px',
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    {/* Header */}
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            <ColoredSettingsEmailConfigurationIcon height={'36px'} width={'36px'} />
                            <span style={{ fontWeight: 600, fontSize: 18 }}>Email Configuration</span>
                        </div>
                    </div>
                    <div style={{ color: '#888', fontSize: 14, marginBottom: 18 }}>
                        Manage details about your email configuration for sending emails
                    </div>
                            <div className="row align-items-top form-group">
                                <div className="col-lg-4 col-md-4 col-4">
                                    <div className={`flex align-items-center`}>
                                        <label htmlFor="">Enable Email Sending</label>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-8">
                                    {
                                        isLoading ? (
                                            <div style={{ width: '100px' }}>
                                                <Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '12px' }} />
                                            </div>
                                        ) : (
                                            <div
                                                className="pddmi-action"
                                                onClick={(e) => {
                                                    setInformation({
                                                        ...information,
                                                        smtp_mail_enabled: information?.smtp_mail_enabled === 'ENABLED' ? 'DISABLED' : 'ENABLED'
                                                    });
                                                }}
                                                   style={{ width: '50px' }}
                                            >
                                                <CustomMUISwitch checked={information?.smtp_mail_enabled === 'ENABLED' ? true : false } />
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                            <div className="row align-items-top form-group">
                                <div className="col-lg-4 col-md-4 col-4">
                                    <div className={`flex align-items-center`}>
                                        <label htmlFor="">Mailer</label>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-8">
                                    
                                    {
                                        isLoading ? (
                                            <div style={{ width: '100%' }}>
                                                <Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '12px' }} />
                                            </div>
                                        ) : (
                                            <input
                                                type="text"
                                                className={`form-control ${ information?.smtp_mail_enabled !== 'ENABLED' ? 'disabled cursor-disabled' : ''}`}
                                                disabled={information?.smtp_mail_enabled !== 'ENABLED' ? true : false }
                                                id="inputName"
                                                value={information?.smtp_mail_mailer}
                                                onChange={(e) => {
                                                    setInformation({ ...information, smtp_mail_mailer: e.target.value });
                                                }}
                                            />
                                        )
                                    }
                                </div>
                           </div>
                           
                            <div className="row align-items-top form-group">
                                <div className="col-lg-4 col-md-4 col-4">
                                    <div className={`flex align-items-center`}>
                                        <label htmlFor="">Host</label>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-8">
                                    {
                                        isLoading ? (
                                            <div style={{ width: '100%' }}>
                                                <Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '12px' }} />
                                            </div>
                                        ) : (
                                            <input      
                                                type="text"
                                                className={`form-control ${ information?.smtp_mail_enabled !== 'ENABLED' ? 'disabled cursor-disabled' : ''}`}
                                                disabled={information?.smtp_mail_enabled !== 'ENABLED' ? true : false }
                                                id="inputName"
                                                value={information?.smtp_mail_host}
                                                onChange={(e) => {
                                                    setInformation({ ...information, smtp_mail_host: e.target.value });
                                                }}
                                            />
                                        )
                                    }
                                </div>
                            </div>
                            <div className="row align-items-top form-group">
                                <div className="col-lg-4 col-md-4 col-4">
                                    <div className={`flex align-items-center`}>
                                        <label htmlFor="">Port</label>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-8">
                                    {
                                        isLoading ? (
                                            <div style={{ width: '100%' }}>
                                                <Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '12px' }} />
                                            </div>
                                        ) : (
                                            <input
                                                type="text"
                                                className={`form-control ${ information?.smtp_mail_enabled !== 'ENABLED' ? 'disabled cursor-disabled' : ''}`}
                                                disabled={information?.smtp_mail_enabled !== 'ENABLED' ? true : false }
                                                id="inputName"
                                                value={information?.smtp_mail_port}
                                                onChange={(e) => {
                                                    setInformation({ ...information, smtp_mail_port: e.target.value });
                                                }}
                                            />
                                        )
                                    }
                                </div>
                            </div>
                            <div className="row align-items-top form-group">
                                <div className="col-lg-4 col-md-4 col-4">
                                    <div className={`flex align-items-center`}>
                                        <label htmlFor="">Username</label>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-8">
                                    {
                                        isLoading ? (
                                            <div style={{ width: '100%' }}>
                                                <Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '12px' }} />
                                            </div>
                                        ) : (
                                            <input
                                                type="text"
                                                className={`form-control ${ information?.smtp_mail_enabled !== 'ENABLED' ? 'disabled cursor-disabled' : ''}`}
                                                disabled={information?.smtp_mail_enabled !== 'ENABLED' ? true : false }
                                                id="inputName"
                                                value={information?.smtp_mail_username}
                                                onChange={(e) => {
                                                    setInformation({ ...information, smtp_mail_username: e.target.value });
                                                }}
                                            />
                                        )
                                    }
                                </div>
                            </div>
                            <div className="row align-items-top form-group">
                                <div className="col-lg-4 col-md-4 col-4">
                                    <div className={`flex align-items-center`}>
                                        <label htmlFor="">Password</label>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-8">
                                    {
                                        isLoading ? (
                                            <div style={{ width: '100%' }}>
                                                <Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '12px' }} />
                                            </div>
                                        ) : (
                                            <input
                                                type="text"
                                                className={`form-control ${ information?.smtp_mail_enabled !== 'ENABLED' ? 'disabled cursor-disabled' : ''}`}
                                                disabled={information?.smtp_mail_enabled !== 'ENABLED' ? true : false }
                                                id="inputName"
                                                value={information?.smtp_mail_password}
                                                onChange={(e) => {
                                                    setInformation({ ...information, smtp_mail_password: e.target.value });
                                                }}
                                            />
                                        )
                                    }
                                </div>
                            </div>
                            <div className="row align-items-top form-group">
                                <div className="col-lg-4 col-md-4 col-4">
                                    <div className={`flex align-items-center`}>
                                        <label htmlFor="">Encryption</label>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-8">
                                    {
                                        isLoading ? (
                                            <div style={{ width: '100%' }}>
                                                <Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '12px' }} />
                                            </div>
                                        ) : (
                                            <input
                                                type="text"
                                                className={`form-control ${ information?.smtp_mail_enabled !== 'ENABLED' ? 'disabled cursor-disabled' : ''}`}
                                                disabled={information?.smtp_mail_enabled !== 'ENABLED' ? true : false }
                                                id="inputName"
                                                value={information?.smtp_mail_encryption}
                                                onChange={(e) => {
                                                    setInformation({ ...information, smtp_mail_encryption: e.target.value });
                                                }}
                                            />
                                        )
                                    }
                                </div>
                            </div>
                            <div className="row align-items-top form-group">
                                <div className="col-lg-4 col-md-4 col-4">
                                    <div className={`flex align-items-center`}>
                                        <label htmlFor="">Sender Email</label>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-8">
                                    {
                                        isLoading ? (
                                            <div style={{ width: '100%' }}>
                                                <Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '12px' }} />
                                            </div>
                                        ) : (
                                            <input
                                                type="text"
                                                className={`form-control ${ information?.smtp_mail_enabled !== 'ENABLED' ? 'disabled cursor-disabled' : ''}`}
                                                disabled={information?.smtp_mail_enabled !== 'ENABLED' ? true : false }
                                                id="inputName"
                                                value={information?.smtp_mail_from_address}
                                                onChange={(e) => {
                                                    setInformation({ ...information, smtp_mail_from_address: e.target.value });
                                                }}
                                            />
                                        )
                                    }
                                </div>
                            </div>
                            <div className="row align-items-top form-group">
                                <div className="col-lg-4 col-md-4 col-4">
                                    <div className={`flex align-items-center`}>
                                        <label htmlFor="">Sender Name</label>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-8">
                                    {
                                        isLoading ? (
                                            <div style={{ width: '100%' }}>
                                                <Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '12px' }} />
                                            </div>
                                        ) : (
                                            <input
                                                type="text"
                                                className={`form-control ${ information?.smtp_mail_enabled !== 'ENABLED' ? 'disabled cursor-disabled' : ''}`}
                                                disabled={information?.smtp_mail_enabled !== 'ENABLED' ? true : false }
                                                id="inputName"
                                                value={information?.smtp_mail_from_name}
                                                onChange={(e) => {
                                                    setInformation({ ...information, smtp_mail_from_name: e.target.value });
                                                }}
                                            />
                                        )
                                    }
                                </div>
                            </div>
                    <div
                        className="btnarea"
                        style={{
                            position: 'sticky',
                            bottom: 0,
                            left: 0,
                            width: '100%',
                            background: '#fff',
                            padding: '16px 0 12px 0',
                            zIndex: 30,
                            display: 'flex',
                            gap: 10,
                            justifyContent: 'center',
                            marginTop: 'auto'
                        }}
                    >
                        <button
                            className="btn btn-main"
                            disabled={isFormProcessing}
                            onClick={() => {
                                if (!isFormProcessing) handleProcessSubmit();
                            }}
                        >
                            {isFormProcessing ? (
                                <>
                                    <FaSpinner className="fa-spin" /> Saving...
                                </>
                            ) : (
                                <>
                                    <FaSave /> Save
                                </>
                            )}
                        </button>
                        <button className="btn new-btn-error" onClick={handleClose}>
                            <FaTimes /> Close
                        </button>
                    </div>
                </div>
            </div>
        );
};

export default EmailConfigurationModal;
